<div class="fixed top-0 left-0 right-0 z-40 border-b border-[#0000000D] w-full bg-white">
    <div class="relative h-[88px] flex w-full items-center bg-transparent py-2.5">

        <!-- Logo -->
        <div class="flex items-center px-6">
            <a routerLink="/" class="w-[160px] h-[56px] flex items-center">
                <img src="/assets/images/sidebar_menu_logo_mas.svg" alt="sidebar_menu_logo_mas" class="w-[160px] h-[56px]" />
            </a>
        </div>

        <!-- Mobile Menu Toggle -->
        <a
            class="collapse-icon flex flex-none rounded-full bg-white-light/40 p-2 hover:bg-white-light/90 hover:text-gray-500 mr-4 lg:hidden"
            (click)="storeData.dispatch({type: 'toggleSidebar'})">
            <icon-menu class="h-5 w-5" />
        </a>

        <!-- Page Title - aligned with content padding -->
        <div class="text-lg font-medium mr-4 truncate lg:ml-16 text-[#1E4684]" [title]="pageTitle">{{pageTitle}}</div>

        <div class="flex items-center space-x-1.5 ml-auto sm:flex-1 sm:ml-0 lg:space-x-2 pr-6">
            <div class="sm:mr-auto"></div>

            <!-- Environment Badge -->
            <div *ngIf="envBadge.show" class="hidden sm:block px-3 py-1 rounded-full text-xs font-semibold text-white"
                 [ngStyle]="{'background-color': envBadge.color}">
                {{ envBadge.label }}
            </div>

            <!-- Notification -->
            <div class="dropdown shrink-0">
                <div hlMenu>
                    <button type="button" hlMenuButton
                        class="relative flex items-center justify-center h-12 w-12 rounded-full bg-white text-primary border border-[#E9E9E9] text-sm font-normal hover:opacity-80">
                        <icon-bell-bing />

                        <!-- Show badge only if there are unread notifications -->
                        <span class="absolute top-0 flex h-3 w-3 right-0" *ngIf="unreadCount > 0">
                            <span
                                class="absolute -top-[3px] inline-flex h-full w-full animate-ping rounded-full bg-success/50 opacity-75 -left-[3px]"></span>
                            <span class="relative inline-flex h-[6px] w-[6px] rounded-full bg-success"></span>
                        </span>
                    </button>
                    <ul *hlMenuItems @toggleAnimation
                        class="top-[50px] w-[300px] divide-y !py-0 text-dark -right-2 sm:w-[380px]">

                        <!-- Header -->
                        <li>
                            <div class="flex items-center justify-between px-4 py-3 font-semibold border-b">
                                <h4 class="text-lg">Notifications</h4>
                                <div class="flex items-center gap-2">
                                    <span *ngIf="unreadCount > 0" class="badge bg-primary/80 text-xs">
                                        {{unreadCount}} nouveau{{unreadCount > 1 ? 'x' : ''}}
                                    </span>
                                    <!-- Refresh button -->
                                    <button type="button" class="text-gray-500 hover:text-gray-700 p-1 rounded"
                                        (click)="refreshNotifications()" [disabled]="isNotificationLoading"
                                        title="Actualiser">
                                        <!-- Use a simple refresh symbol or existing icon -->
                                        <svg class="h-4 w-4" [class.animate-spin]="isNotificationLoading" fill="none"
                                            viewBox="0 0 24 24" stroke="currentColor">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </li>
                        <!-- Loading State -->
                        <li *ngIf="isNotificationLoading && notifications.length === 0">
                            <div class="flex items-center justify-center py-8">
                                <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
                                <span class="ml-2 text-gray-500">Chargement...</span>
                            </div>
                        </li>
                        <!-- Notifications List with Scroll -->
                        <li *ngIf="notifications.length > 0 && !isNotificationLoading" class="overflow-hidden">
                            <div class="max-h-[400px] overflow-y-auto">
                                <div *ngFor="let notification of notifications; let i = index"
                                    class="hover:bg-gray-50 border-b border-gray-100 last:border-b-0 cursor-pointer"
                                    [class.bg-blue-50]="isNotificationUnread(notification)"
                                    (click)="openNotification(notification)">
                                    <div class="group flex items-start px-4 py-3">
                                        <div class="grid place-content-center rounded mr-3">
                                            <div class="relative h-10 w-10">
                                                <div
                                                    class="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                                                    <icon-bell-bing class="h-5 w-5 text-primary" />
                                                </div>
                                                <!-- Unread indicator -->
                                                <span *ngIf="isNotificationUnread(notification)"
                                                    class="absolute -top-1 -right-1 block h-3 w-3 rounded-full bg-success"></span>
                                            </div>
                                        </div>

                                        <div class="flex-1 min-w-0">
                                            <h6 class="font-semibold text-sm text-gray-800 mb-1 truncate">
                                                {{notification.titre_fr}}
                                            </h6>
                                            <p class="text-xs text-gray-600 mb-2 line-clamp-2 leading-relaxed">
                                                {{notification.description_fr}}
                                            </p>
                                            <div class="flex items-center justify-between">
                                                <span class="text-xs text-gray-400">
                                                    {{formatNotificationDate(notification.date_creation)}}
                                                </span>
                                                <div class="flex items-center gap-1">
                                                    <span
                                                        class="inline-block text-xs bg-red-100 text-red-800 px-2 py-1 rounded"
                                                        *ngIf="notification.priorite === 'HIGH'">
                                                        Priorité haute
                                                    </span>
                                                    <button type="button"
                                                        class="text-gray-400 hover:text-red-500 p-1 rounded opacity-0 group-hover:opacity-100 transition-opacity"
                                                        (click)="$event.stopPropagation(); removeNotification(notification.id_notification)"
                                                        title="Marquer comme lu">
                                                        <!-- Use SVG X icon instead of icon-x -->
                                                        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                                            stroke="currentColor">
                                                            <path stroke-linecap="round" stroke-linejoin="round"
                                                                stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <!-- Action Buttons -->
                        <li *ngIf="notifications.length > 0 && !isNotificationLoading">
                            <div class="p-4 bg-gray-50">
                                <div class="flex gap-2">
                                    <button type="button" class="btn btn-primary btn-sm flex-1 text-xs py-2"
                                        (click)="markAllAsRead()" [disabled]="unreadCount === 0"
                                        *hlMenuItem="let menuItem">
                                        Marquer tout comme lu
                                    </button>
                                </div>
                            </div>
                        </li>

                        <!-- Empty state -->
                        <li *ngIf="notifications.length === 0 && !isNotificationLoading">
                            <div class="!grid min-h-[200px] place-content-center text-lg hover:!bg-transparent">
                                <div class="mx-auto mb-4 rounded-full text-primary ring-4 ring-primary/30">
                                    <icon-info-circle [fill]="true" class="h-10 w-10" />
                                </div>
                                <p class="text-gray-500 text-center text-sm">Aucune notification disponible.</p>
                                <button type="button" class="mt-3 btn btn-outline-primary btn-sm"
                                    (click)="refreshNotifications()">
                                    Actualiser
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

        </div>
    </div>
</div>